// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.article-img-container {
  flex: 1;
  margin-bottom: 20px;
}
.article-img-container .article-img {
  width: 100%;
}

.article-title {
  margin-bottom: 45px;
  font-weight: 500;
}

.article-about {
  font-size: 0.75em;
}
.article-about .article-about-author {
  color: black;
  font-weight: 500;
  margin-right: 5px;
}
.article-about .article-about-author {
  color: slategray;
}

.andrena-card {
  display: block;
  position: relative;
  box-sizing: border-box;
  min-width: 156px;
  width: 100%;
  box-shadow: var(--ds-shadow-raised, 0 1px 1px rgba(9, 30, 66, 0.25), 0 0 1px 1px rgba(9, 30, 66, 0.13));
  border-radius: 3px;
  cursor: pointer;
  margin-right: 20px;
}

.card-content {
  font-size: 1em;
  text-decoration: none;
  color: black;
  overflow: hidden;
  max-width: inherit;
  text-overflow: ellipsis;
  padding: 10px;
}

.empty-slot-card {
  border: 1px solid rgba(229, 229, 255, 0.8);
  padding: 16px;
  border-radius: 10px;
  cursor: pointer;
  margin-right: 20px;
}

.empty-slot .article-title {
  margin-bottom: 20px;
}

.empty-slot-img-container {
  height: 100%;
  margin-bottom: 26px;
}
.empty-slot-img-container img {
  width: 100%;
}

.article-card {
  border: 1px solid rgba(229, 229, 255, 0.8);
  padding: 16px;
  border-radius: 10px;
  flex: 1 1 45%;
  height: 310px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/cards/empty-article-card/empty-article-card.component.scss"],"names":[],"mappings":"AAOA;EACI,OAAA;EACA,mBAAA;AANJ;AAQI;EACI,WAAA;AANR;;AAUA;EACI,mBAAA;EACA,gBAAA;AAPJ;;AAUA;EACI,iBAAA;AAPJ;AASI;EACI,YAAA;EACA,gBAAA;EACA,iBAAA;AAPR;AASI;EACI,gBAAA;AAPR;;AAWA;EACI,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,uGAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AARJ;;AAYA;EAEI,cAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,aAAA;AAVJ;;AAcA;EACI,0CAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AAXJ;;AAiBA;EACI,mBAAA;AAdJ;;AAiBA;EACI,YAAA;EACA,mBAAA;AAdJ;AAeI;EACI,WAAA;AAbR;;AAiBA;EACI,0CAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;AAdJ","sourcesContent":["// #recommendations-card-container .article-img {\n//     display: block;\n//     height: 150px;\n//     width: 270px;\n//     margin-right: 20px;\n// }\n\n.article-img-container {\n    flex: 1;\n    margin-bottom: 20px;\n\n    .article-img {\n        width: 100%;\n    }\n}\n\n.article-title {\n    margin-bottom: 45px;\n    font-weight: 500;\n}\n\n.article-about {\n    font-size: 0.75em;\n\n    .article-about-author {\n        color: black;\n        font-weight: 500;\n        margin-right: 5px;\n    }\n    .article-about-author {\n        color: slategray;\n    }\n}\n\n.andrena-card {\n    display: block;\n    position: relative;\n    box-sizing: border-box;\n    min-width: 156px;\n    width: 100%;\n    box-shadow: var(--ds-shadow-raised, 0 1px 1px rgba(9, 30, 66, 0.25), 0 0 1px 1px rgba(9, 30, 66, 0.13));\n    border-radius: 3px;\n    cursor: pointer;\n    margin-right: 20px;\n    // padding: 10px;\n}\n\n.card-content {\n    //font-weight: 500;\n    font-size: 1em;\n    text-decoration: none;\n    color: black;\n    overflow: hidden;\n    max-width: inherit;\n    text-overflow: ellipsis;\n    padding: 10px;\n}\n\n\n.empty-slot-card {\n    border: 1px solid rgba(229, 229, 299, 80%);\n    padding: 16px;\n    border-radius: 10px;\n    cursor: pointer;\n    margin-right: 20px;\n    // padding: 10px;\n\n\n}\n\n.empty-slot .article-title {\n    margin-bottom: 20px;\n}\n\n.empty-slot-img-container {\n    height: 100%;\n    margin-bottom: 26px;\n    img {\n        width: 100%;\n    }\n}\n\n.article-card {\n    border: 1px solid rgba(229, 229, 299, 80%);\n    padding: 16px;\n    border-radius: 10px;\n    flex: 1 1 45%;\n    height: 310px;\n    // &:nth-last-child(n+2) {\n    //     margin-right: 2%;\n    // }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
